<template>
    <div>
        <tabs class="ses-tabs" :fill="0" :pills="0" :activeTab="0">
            <card shadow>

                <tab-pane :key="0" title="General" :id="0">
                    <form @submit.prevent="submit('general')">
                        <div class="row">
                            <div class="col-md-12">

                                <div class="section">
                                    
                                    <h3>Drop Ship</h3>
                                    <div class="form-group">
                                        <label>Fee</label>
                                        <input type="number" class="form-control" v-model="drop_ship_fee" step="any" min="0">
                                    </div>
                                    
                                    <h3>No Tariff Quote Validity</h3>
                                    <div class="form-group">
                                        <label>Days</label>
                                        <input type="number" class="form-control" v-model="notariff_validity" step="any" min="0">
                                    </div>
                                    
                                    <h3>Freight Surcharge</h3>
                                    <div class="form-group">
                                        <label>Fee</label>
                                        <input type="number" class="form-control" v-model="freight_surcharge" step="any" min="0">
                                    </div>
                                    
                                    <h3>Stock Lead Time</h3>
                                    <div class="form-group">
                                        <label>Weeks</label>
                                        <input type="number" class="form-control" v-model="stock_leadtime" step="any" min="0">
                                    </div>

                                    <h3>Drawing Fee</h3>
                                    <div class="row">
                                        <div class="form-group col-md-2">
                                            <label>Per Car</label>
                                            <input type="number" step="any" min="0" class="form-control" v-model="drawing_per_car_fee">
                                        </div>
                                        <div class="form-group col-md-2">
                                            <label>Max Fee</label>
                                            <input type="number" step="any" min="0" class="form-control" v-model="drawing_max_fee">
                                        </div>
                                    </div>
                                </div>
                                <div class="section">
                                    <h3>Parts Manager</h3>
                                    <div class="form-group">
                                        <label>Email</label>
                                        <input type="email" class="form-control" v-model="parts_manager_email">
                                    </div>
                                </div>
                                <div class="section">
                                    <h3>Selling Point Manager</h3>
                                    <div class="form-group">
                                        <label>Email</label>
                                        <input type="email" class="form-control" v-model="selling_point_email">
                                    </div>
                                    <h3>Selling Point Other Emails <small>Can be many just separate with comma</small></h3>
                                    <div class="form-group">
                                        <label>Email</label>
                                        <input type="email" class="form-control" v-model="selling_point_other_email">
                                    </div>
                                </div>
                                <div class="section">
                                    <h3>LiftNet Manager</h3>
                                    <div class="form-group">
                                        <label>Email</label>
                                        <input type="email" class="form-control" v-model="liftnet_email">
                                    </div>
                                    <h3>LiftNet Other Emails <small>Can be many just separate with comma</small></h3>
                                    <div class="form-group">
                                        <label>Email</label>
                                        <input type="email" class="form-control" v-model="liftnet_other_email">
                                    </div>
                                </div>
                                <div class="section">
                                    <h3>Threshold Manager</h3>
                                    <div class="form-group col-md-2">
                                        <label>Threshold <small>($)</small></label>
                                        <input type="number" step="any" min="0" class="form-control" v-model="threshold_amount">
                                    </div>
                                    <div class="form-group col-md-12">
                                        <label>Email</label>
                                        <input type="text" class="form-control" v-model="threshold_manager">
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="button-group">
                                    <button class="btn btn-black" type="submit" :disabled="isSubmitting">
                                        <template v-if="isSubmitting"><span class="fa fa-spinner fa-pulse"></span></template>
                                        <template v-else>Save</template>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </tab-pane>

                <!-- <tab-pane :key="1" title="Rewards" :id="1">
                    <form @submit.prevent="submit('rewards')">
                        <div class="row">
                            <div class="col-md-12">

                                <div class="section">
                                    <h3>Login Reward</h3>
                                    <div class="form-group">
                                        <label>Gift Card</label>
                                        <select-gift-card :default_gift_card="rewards_login.gift_card" @select="login_gift_card"></select-gift-card>
                                    </div>
                                    <div class="form-group">
                                        <label>Max Reward</label>
                                        <input type="number" class="form-control" v-model="rewards_login.max" min="0">
                                    </div>
                                </div>
                                <div class="section">
                                    <h3>Final Proposal Reward</h3>
                                    <div class="form-group">
                                        <label>Gift Card</label>
                                        <select-gift-card :default_gift_card="rewards_final_proposal.gift_card" @select="final_proposal_gift_card"></select-gift-card>
                                    </div>
                                    <div class="form-group">
                                        <label>Max Reward</label>
                                        <input type="number" class="form-control" v-model="rewards_final_proposal.max" min="0">
                                    </div>
                                </div>
                                <div class="section">
                                    <h3>Purchase Reward</h3>
                                    <div class="form-group">
                                        <label>Gift Card</label>
                                        <select-gift-card :default_gift_card="rewards_purchase.gift_card" @select="purchase_gift_card"></select-gift-card>
                                    </div>
                                    <div class="form-group">
                                        <label>Max Reward</label>
                                        <input type="number" class="form-control" v-model="rewards_purchase.max" min="0">
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="button-group">
                                    <button class="btn btn-black" type="submit" :disabled="isSubmitting">
                                        <template v-if="isSubmitting"><span class="fa fa-spinner fa-pulse"></span></template>
                                        <template v-else>Save</template>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </tab-pane> -->

                <tab-pane :key="1" title="Success Message" :id="1">
                    <form @submit.prevent="submit('success_msg')">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="section">
                                    <h3>Request Support</h3>
                                    <div class="form-group">
                                        <label>Message</label>
                                        <textarea class="form-control" v-model="req_support_success_msg"></textarea>
                                    </div>
                                    <div class="form-group">
                                        <label>Image</label>
                                        <input type="file" class="form-control" ref="req_support_success_image_file" @change="on_select_file($event, 'req_support_success_image')" accept="image/*">
                                        <div class="text-center mt-4">
                                            <img v-if="req_support_success_image" :src="req_support_success_image" style="width: 30em;">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="button-group">
                                    <button class="btn btn-black" type="submit" :disabled="isSubmitting">
                                        <template v-if="isSubmitting"><span class="fa fa-spinner fa-pulse"></span></template>
                                        <template v-else>Save</template>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </tab-pane>

                <tab-pane :key="2" title="Storage" :id="2">
                    <form @submit.prevent="submit('storage')">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="section">
                                    <h3>Storage Monitoring</h3>
                                    <div class="form-group">
                                        <label>Storage : {{ storage.storage_percentage }} <small>({{storage.storage_used}} / {{storage.storage_capacity}})</small></label>
                                        <div class="progress">
                                            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" :style="'width:'+storage.storage_percentage"></div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Threshold (%)</label>
                                        <input type="number" class="form-control" v-model="storage_threshold" step="any" min="0" max="100">
                                    </div>
                                    <div class="form-group">
                                        <label>Email Recipients <small>(comma separated)</small></label>
                                        <input type="text" class="form-control" v-model="storage_emails">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="button-group">
                                    <button class="btn btn-black" type="submit" :disabled="isSubmitting">
                                        <template v-if="isSubmitting"><span class="fa fa-spinner fa-pulse"></span></template>
                                        <template v-else>Save</template>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </tab-pane>
                
            </card>
        </tabs>
    </div>
</template>
<script>
// import SelectGiftCard from '../../components/SelectGiftCard.vue'

export default {
    data() {
        return {
            isLoading: false,
            isSubmitting: false,
            settings: [],
            storage: [],
            drop_ship_fee: 0,
            notariff_validity: 90,
            freight_surcharge: 0,
            stock_leadtime: 4,
            drawing_per_car_fee: 0,
            drawing_max_fee: 0,
            parts_manager_email: '',
            selling_point_email: '',
            selling_point_other_email: '',
            threshold_amount: 0,
            threshold_manager: '',
            rewards_login: { max: 1, gift_card: {} },
            rewards_final_proposal: { max: 1, gift_card: {} },
            rewards_purchase: { max: 1, gift_card: {} },
            req_support_success_msg: '',
            req_support_success_image: '',
            req_support_success_image_file: false,
            storage_threshold: 90,
            storage_emails: ''
        }
    },
    // components: { 
    //     SelectGiftCard
    // },
    mounted() {
        this.get_settings()
    },
    methods: {
        submit(tab) {
            this.isSubmitting = true
            let settings = []
            let fdata = new FormData()

            if(tab == 'general') {
                settings = [
                    { key: 'drop_ship_fee', value: this.drop_ship_fee },
                    { key: 'notariff_validity', value: this.notariff_validity },
                    { key: 'freight_surcharge', value: this.freight_surcharge },
                    { key: 'stock_leadtime', value: this.stock_leadtime },
                    { key: 'drawing_per_car_fee', value: this.drawing_per_car_fee },
                    { key: 'drawing_max_fee', value: this.drawing_max_fee },
                    { key: 'parts_manager_email', value: this.parts_manager_email },
                    { key: 'selling_point_email', value: this.selling_point_email },
                    { key: 'selling_point_other_email', value: this.selling_point_other_email },
                    { key: 'threshold_amount', value: this.threshold_amount },
                    { key: 'threshold_manager', value: this.threshold_manager }
                ]
            } else if(tab == 'rewards') {
                settings = [
                    { key: 'rewards_login', value: JSON.stringify(this.rewards_login) },
                    { key: 'rewards_final_proposal', value: JSON.stringify(this.rewards_final_proposal) },
                    { key: 'rewards_purchase', value: JSON.stringify(this.rewards_purchase) } 
                ]
            } else if(tab == 'success_msg') {
                settings = [
                    { key: 'req_support_success_msg', value: this.req_support_success_msg },
                    { key: 'req_support_success_image', value: this.req_support_success_image }
                ]
                fdata.append('req_support_success_image_file', this.req_support_success_image_file)
            } else if(tab == 'storage') {
                settings = [
                    { key: 'storage_threshold', value: this.storage_threshold },
                    { key: 'storage_emails', value: this.storage_emails }
                ]
            }

            fdata.append('settings', JSON.stringify(settings))

            this.$http.post('/api/settings', fdata, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then(() => {
                    alert('Saved!')
                    this.isSubmitting = false
                })
                .catch(() => {
                    alert('Something went wrong!')
                    this.isSubmitting = false
                })
        },
        get_settings() {
            this.isLoading = true
            this.$http.get('/api/settings')
                .then((response) => {
                    this.settings = response.data.data
                    this.storage = response.data.storage
                    for(let n in this.settings) {
                        let key = this.settings[n].setting_key
                        let value = this.settings[n].setting_value

                        if(key == 'rewards_login' 
                            || key == 'rewards_final_proposal'
                            || key == 'rewards_purchase'
                        ) {
                            this[key] = JSON.parse(value)
                        } else {
                            this[key] = value
                        }
                    }
                    this.isLoading = false
                })
        },
        on_select_file(event, key) {
            const files = event.target.files
            const fileReader = new FileReader()
            fileReader.addEventListener('load', () => {
                this[key] = fileReader.result
            })
            fileReader.readAsDataURL(files[0])
            this[`${key}_file`] = files[0]
        },
        login_gift_card(gift_card) {
            this.rewards_login.gift_card = gift_card
        },
        final_proposal_gift_card(gift_card) {
            this.rewards_final_proposal.gift_card = gift_card
        },
        purchase_gift_card(gift_card) {
            this.rewards_purchase.gift_card = gift_card
        }
    }
}
</script>
<style lang="scss" scoped>
.section {
    border-bottom: 1px solid #e6e6e6;
    margin-bottom: 1em;
    padding-bottom: 0.5em;
}
input[type=number] {
    max-width: 5em;
}
</style>